import shop from '../api/shop';
import {
  PRODUCT_DETAIL_STORE,
  PRODUCT_STORE,
  MORE_PRODUCT_STORE,
  CHANGE_PRODUCT_QUANTITY,
  FILTER_PRODUCTS,
  DELETE_ALL_PRODUCTS_QUANTITY,
  SEARCH_BY,
  SEARCHED_PRODUCTS,
  CLEAR_SEARCH,
  PRODUCTS_SORT_BY,
  PRODUCTS_SORT_ORDER,
  SET_LOBBED_QUANTITY,
  HANDLE_LOBBED_PRODUCT,
  COMMON_OPEN_MODAL,
  SET_LOBBED_PRICE,
  LOADING_PRODUCTS,
  LOADING_MORE_PRODUCTS,
  SEARCHING_PRODUCTS,
  IMPORT_SEARCHED_PRODUCTS,
  CLEAR_CUSOMER_DATA,
  SET_PRODUCT_LIST,
  MORE_PRODUCT_FETCH,
  SORTED_FULL_PRODUCT_STORE,
  SORTED_PRODUCT_STORE,
  SORT_PRODUCTS,
  RESET_STATE,
  CART_STORE,
  FILTER_CLEAR,
  SHOWING_HOT_PRODUCTS,
  CUSTOMER_ACTION_TYPE,
} from './actionTypes';
import { productState } from './stateModel';
import { storeOrderData } from './order';
import removeAccents from 'remove-accents';

// ------------------------------------
// Actions
// ------------------------------------

const loadingSearchUnsafe = loading => ({
  type: SEARCHING_PRODUCTS,
  loading
})

const loadingUnsafe = loading => ({
  type: LOADING_PRODUCTS,
  loading
})

export const loadingProducts = state => dispatch => {
  dispatch(loadingUnsafe(state))
};

const loadingMoreUnsafe = loading => ({
  type: LOADING_MORE_PRODUCTS,
  loading
})

export const loadingMoreProducts = state => dispatch => {
  dispatch(loadingMoreUnsafe(state))
};

const receiveMoreProducts = products => ({
  type: MORE_PRODUCT_STORE,
  products
})

export const storeMoreProducts = products => dispatch => {
  dispatch(receiveMoreProducts(products))
};

const fetchMoreProductsUnsafe = offset => ({
  type: MORE_PRODUCT_FETCH,
  offset
})

export const fetchMoreProducts = offset => dispatch => {
  dispatch(fetchMoreProductsUnsafe(offset))
};

export const storeProducts = products => dispatch => {
  dispatch(changeProductsListUnsafe(products))
};
export const storeProductsAndFilter = (
  products,
  category,
  compatibility
) => dispatch => {
  const categoryList = category.split(',')
  const compatibilityList = compatibility && compatibility.split(',')
  const filteredProducts = categoryList
    .map(cat => {
      return products.filter(p => {
        const prodCats = p.category && p.category.split(',')
        return prodCats && prodCats.includes(cat)
      })
    })
    .reduce((a, b) => [...a, ...b], [])
  // console.log(filteredProducts);
  let finalProductList = [...filteredProducts]
  if (compatibilityList) {
    finalProductList = compatibilityList
      .map(alt => {
        return products.filter(p => {
          const prodAlts = p.compatibility && p.compatibility.split(',')
          return prodAlts && prodAlts.includes(alt)
        })
      })
      .reduce((a, b) => [...a, ...b], [])
    if (finalProductList.length === 0) finalProductList = [...filteredProducts]
  }
  dispatch(changeProductsListUnsafe(finalProductList))
};

const receiveProductDetail = product => ({
  type: PRODUCT_DETAIL_STORE,
  product
})

export const storeProductDetail = product => dispatch => {
  dispatch(receiveProductDetail(product))
};

const changeProductQuantityUnsafe = product => ({
  type: CHANGE_PRODUCT_QUANTITY,
  product
})

export const changeProductQuantity = (productId, quantity) => dispatch => {
  dispatch(changeProductQuantityUnsafe({ id: productId, quantity: quantity }))
};

const changeProductsListUnsafe = products => ({
  type: PRODUCT_STORE,
  products
})
const changeProductsFullListUnsafe = products => ({
  type: SORTED_FULL_PRODUCT_STORE,
  products
})

const changeFilterUnsafe = (term, col, langId) => ({
  type: FILTER_PRODUCTS,
  term,
  col,
  langId
})

export const changeFilter = () => () => { }

export const changeProductsList = (term, type, langId) => dispatch => {
  dispatch(loadingUnsafe(true))
  dispatch(changeFilterUnsafe(term, type, langId))
  dispatch(loadingUnsafe(false))
};

const sortProductsUnsafe = (sortBy, sortOrder) => ({
  type: SORT_PRODUCTS,
  sortBy,
  sortOrder
})

export const sortProductsList = (sortBy, sortOrder) => (dispatch, getState) => {
  dispatch(loadingUnsafe(true))
  dispatch(sortProductsUnsafe(sortBy, sortOrder))
  dispatch(loadingUnsafe(false))
};

const changeSortByUnsafe = sortBy => ({
  type: PRODUCTS_SORT_BY,
  sortBy
})

export const changeProductsSortBy = sortBy => dispatch => {
  dispatch(changeSortByUnsafe(sortBy))
};

const changeSortOrderUnsafe = sortOrder => ({
  type: PRODUCTS_SORT_ORDER,
  sortOrder
})

const clearFilterUnsafe = ftype => ({
  type: FILTER_CLEAR,
  ftype
})
export const clearFilter = type => dispatch => {
  dispatch(clearFilterUnsafe(type))
  dispatch(changeProductsList(null, null))
};

export const changeProductsSortOrder = sortOrder => dispatch => {
  dispatch(changeSortOrderUnsafe(sortOrder))
};

const setSearchTermUnsafe = term => ({
  type: SEARCH_BY,
  term
})

const setSearchedProductUnsafe = products => ({
  type: SEARCHED_PRODUCTS,
  products
})

const importSearchedProductsUnsafe = () => ({
  type: IMPORT_SEARCHED_PRODUCTS
})

export const setSearchTerm = val => dispatch =>
  dispatch(setSearchTermUnsafe(val))
export const importSearchedProducts = () => dispatch =>
  dispatch(importSearchedProductsUnsafe())

export const searchProduct = val => (dispatch, getState) => {
  dispatch(loadingSearchUnsafe(true))
  shop.searchProducts(
    val,
    getState().customer.actionOnCustomer,
    getState().common.user.personal.id,
    searchedProductsFromApi => {
      searchedProductsFromApi.then(searchedProducts => {
        dispatch(setSearchedProductUnsafe(searchedProducts))
        dispatch(loadingSearchUnsafe(false))
      })
    }
  )
};

const clearSearchUnsafe = () => ({
  type: CLEAR_SEARCH
})

export const clearSearch = () => dispatch => {
  dispatch(clearSearchUnsafe())
};

const saveLobbedProdUnsafe = product => ({
  type: HANDLE_LOBBED_PRODUCT,
  product
})

export const openProductModal = id => (dispatch, getState) => {
  if (getState().product.fullList.length > 0) {
    dispatch(
      receiveProductDetail(getState().product.fullList.find(p => p.id === id))
    )
    dispatch(openModalUnsafe('product_modal'))
  }
}

export const openOrderModal = id => (dispatch, getState) => {
  dispatch(storeOrderData(null));
  dispatch(openModalUnsafe('order_modal'))
  shop.getOrder_detail(id, orderPromise => {
    orderPromise.then(order => {
      console.log(order);
      dispatch(storeOrderData(order));
    });
  }, 0)
}

export const openLobingModal = () => dispatch => {
  shop.getProductDetail(product => {
    dispatch(saveLobbedProdUnsafe(product))
    dispatch(openModalUnsafe('lobing_modal'))
  }, 500)
};

const openModalUnsafe = modal => ({
  type: COMMON_OPEN_MODAL,
  modal
})

const setLobbedQuantityUnsafe = quantity => ({
  type: SET_LOBBED_QUANTITY,
  quantity
})

export const setLobbedQuantity = quantity => dispatch => {
  dispatch(setLobbedQuantityUnsafe(quantity))
};

const lobNewPriceUnsafe = newPrice => ({
  type: SET_LOBBED_PRICE,
  newPrice
})

export const lobNewPrice = (quantity, price) => dispatch => {
  shop.getLobbedPrice(
    quantity,
    price,
    newPrice => {
      dispatch(lobNewPriceUnsafe(newPrice))
    },
    500
  )
};

export const getProductOzPrice = (state, productId) => {
  const pp = state.list.find(product => product.id === productId)
  if (pp.sale) { return pp.priceSale }
  return pp.ozPrice > 0 ? pp.ozPrice : pp.price
};

export const setOZPrice = (productId, value) => (dispatch, getState) => {
  const { list } = getState().product
  list.find(product => product.id === productId).ozPrice = value
  list.find(product => product.id === productId).editation = false
  dispatch(setEditationPriceUnsafe(list))
};

export const getProductEditation = (state, productId) =>
  state.list.find(product => product.id === productId).editation

export const setEditationPrice = productId => (dispatch, getState) => {
  const { list } = getState().product
  list.find(product => product.id === productId).editation = true
  dispatch(setEditationPriceUnsafe(list))
};

const setEditationPriceUnsafe = products => ({
  type: SET_PRODUCT_LIST,
  products
})

export const getVisibleProducts = state => (!state.list ? [] : state.list)
export const getProductDetail = state => (!state ? {} : state)
export const getProductQuantity = (state, productId) => {
  if (!productId || !state) return undefined
  const productQuantity = !state
    ? undefined
    : state.find(p => p.id === productId)
  return productQuantity ? productQuantity.quantity : undefined
};
export const getSearchTerm = state => (!state ? '' : state)
export const getSearchedProducts = state => (!state ? [] : state)
export const getLobbedProduct = state => state || false
export const getCategoryID = state => state || 0
export const getOffset = state => state || 0

// ------------------------------------
// Reducer
// ------------------------------------

const sortProduct = (list, sortBy, sortOrder) => {
  if (list.length === 0) return [];
  let dataSorted = [];
  switch (sortBy) {
    case 'date':
      dataSorted = list.sort((a, b) => new Date(b.date) - new Date(a.date))
      break
    case 'price':
    case 'marza':
      dataSorted = list.sort((a, b) => a[sortBy] - b[sortBy])
      break

    default:
      dataSorted = list.sort((a, b) =>
        a[sortBy]
          .toString()
          .toLowerCase()
          .localeCompare(b[sortBy].toString().toLowerCase())
      );
      break
  }

  return sortOrder === 'asc' ? dataSorted : dataSorted.reverse()
}

const slug = str => {
  str = str.replace(/^\s+|\s+$/g, ''); // trim
  str = str.toLowerCase();

  // remove accents, swap ñ for n, etc
  const from =
    'ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆĞÍÌÎÏİŇÑÓÖÒÔÕØŘŔŠŞŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇğíìîïıňñóöòôõøðřŕšşťúůüùûýÿžþÞĐđßÆa·/_,:;';
  const to =
    'AAAAAACCCDEEEEEEEEGIIIIINNOOOOOORRSSTUUUUUYYZaaaaaacccdeeeeeeeegiiiiinnooooooorrsstuuuuuyyzbBDdBAa------';
  for (let i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  str = str
    .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-'); // collapse dashes

  return str;
};

const getSortedProduct = (list, sortBy, sortOrder) => {

  // FMO, PGU, PPL, PKK, PKO      
  const FMOProducts = list.filter(p => p && p.code && p.code.startsWith('FMO'));
  const PGUProducts = list.filter(p => p && p.code && p.code.startsWith('PGU'));
  const PPLProducts = list.filter(p => p && p.code && p.code.startsWith('PPL'));
  const PKKProducts = list.filter(p => p && p.code && p.code.startsWith('PKK'));
  const PKOProducts = list.filter(p => p && p.code && p.code.startsWith('PKO'));
  const OtherProducts = list.filter(p => p && p.code && !p.code.startsWith('FMO') && p && p.code && !p.code.startsWith('PGU') && p && p.code && !p.code.startsWith('PPL') && p && p.code && !p.code.startsWith('PKK') && p && p.code && !p.code.startsWith('PKO'));

  return [...sortProduct(FMOProducts, sortBy, sortOrder), ...sortProduct(PGUProducts, sortBy, sortOrder), ...sortProduct(PPLProducts, sortBy, sortOrder), ...sortProduct(PKKProducts, sortBy, sortOrder), ...sortProduct(PKOProducts, sortBy, sortOrder), ...sortProduct(OtherProducts, sortBy, sortOrder)]
}

export default function productReducer(state = productState, action) {
  // debugger;
  switch (action.type) {
    case CART_STORE:
      return {
        ...state,
        inCart: Array.isArray(action.cart) ? action.cart : []
      }
    case PRODUCT_STORE:
      const list = action.products ? sortProduct(action.products, state.sortBy, state.sortOrder) : [];
      return {
        ...state,
        loaded: true,
        fullList: action.products,
        filteredList: list,
        list: list.slice(0, 24)
      }
    case SORTED_PRODUCT_STORE:
      return {
        ...state,
        list: action.products
      }
    case SORTED_FULL_PRODUCT_STORE:
      return {
        ...state,
        fullList: action.products
      }
    case MORE_PRODUCT_STORE:
      return {
        ...state,
        filteredList: action.products,
        fullList: action.products
      }
    case MORE_PRODUCT_FETCH:
      const count = ++action.offset * 24
      return {
        ...state,
        list: state.filteredList.slice(0, count)
      }
    case SET_PRODUCT_LIST:
      return {
        ...state,
        list: action.products
      }
    case PRODUCT_DETAIL_STORE:
      return {
        ...state,
        detail: action.product
      }
    case CHANGE_PRODUCT_QUANTITY:
      let pg = Object.assign([], state.inCart)
      if (pg.findIndex(p => p.id === action.product.id) !== -1) {
        if (action.product.quantity) {
          pg.find(p => p.id === action.product.id).quantity =
            action.product.quantity
        } else {
          let pgi = pg.findIndex(p => p.id === action.product.id)
          pg.splice(pgi, 1)
        }
      } else {
        pg.push({ id: action.product.id, quantity: action.product.quantity })
      }
      return {
        ...state,
        inCart: pg
      }
    case DELETE_ALL_PRODUCTS_QUANTITY:
      return {
        ...state,
        inCart: []
      }
    case SEARCH_BY:
      return {
        ...state,
        searchBy: action.term
      }

    case CUSTOMER_ACTION_TYPE: return { ...state, filter: [] }
    case FILTER_CLEAR:
      const flc = Object.assign([], state.filter)
      return {
        ...state,
        filter: flc.filter(f => f.type !== action.ftype)
      }
    case FILTER_PRODUCTS:
      // console.log(state.filter);
      let fl = Object.assign([], state.filter)
      if (action.col) {
        let fi = fl.findIndex(f => f.type === action.col)
        if (fi !== -1) {
          if (parseInt(action.term) === -1 || action.term === '') {
            // console.log(fl);
            // console.log(action);
            // console.log(`-1: action.term: ${action.term}`);
            fl.splice(fi, 1)
          } else if (!action.term) {
            // console.log(fl);
            // console.log(action);
            // console.log(`neq: action.term: ${action.term}`);
            fl.splice(fi, 1)
          } else {
            // console.log(fl);
            // console.log(action);
            // console.log(`add: action.term: ${action.term}`);
            fl[fi].value = action.term
          }
        } else {
          fl.push({ type: action.col, value: action.term })
        }
      }

      if (!action.term) {
        const ff = fl.filter(f => f.type != action.col);
        fl = [...ff];
      }

      let filteredProducts = state.fullList.filter(product =>
        fl.every(filter => {
          if (filter.type === 'compatibility') {
            const comps = product[filter.type] ? product[filter.type].split(',') : []
            return comps && comps.findIndex(c => (c.trim().toString().toLowerCase()) === (filter.value.trim().toString().toLowerCase())) !== -1

          } else if (filter.type === 'color') {
            return (
              product[filter.type].findIndex(
                p => p === Number(filter.value)
              ) !== -1
            )
          } else if (filter.type === 'flex_name') {
            const fn = product.texts[action.langId].name;
            if (fn) {
              const term = removeAccents(filter.value).trim().toString().toLowerCase();
              const candidateString = removeAccents(fn).trim().toString().toLowerCase();
              const inputArr = term.split(" ");
              if (inputArr.length > 1) {
                return inputArr.every(i => {
                  return candidateString.includes(i);
                });
              }
              return candidateString.includes(term);
            } return false;

          } else if (filter.type === 'sale') {
            return product.sale === filter.value;
          } else {
            return product[filter.type]
              ? product[filter.type]
                .toString()
                .toLowerCase()
                .includes(filter.value.toString().toLowerCase())
              : false
          }
          // product[filter.type].toString()
          //   .toLowerCase()
          //   .includes(filter.value.toString().toLowerCase())
        })
      )

      let finalList = [];
      if (fl.length === 0) {
        finalList = sortProduct(filteredProducts, state.sortBy, state.sortOrder);
      } else {
        finalList = getSortedProduct(filteredProducts, state.sortBy, state.sortOrder);
      }
      return {
        ...state,
        filter: fl,
        filteredList: finalList,
        list: finalList.slice(0, 24),
        loading: false
      }

    case SORT_PRODUCTS:
      const dateSortedAndOrdered = sortProduct(state.filteredList, action.sortBy, action.sortOrder);
      return {
        ...state,
        filteredList: dateSortedAndOrdered,
        list: dateSortedAndOrdered.slice(0, 24)
      }
    case SEARCHED_PRODUCTS:
      return {
        ...state,
        searchList: action.products
      }
    case CLEAR_SEARCH:
      return {
        ...state,
        searchList: [],
        searchBy: null
      }
    case PRODUCTS_SORT_BY:
      return {
        ...state,
        sortBy: action.sortBy
      }
    case PRODUCTS_SORT_ORDER:
      return {
        ...state,
        sortOrder: action.sortOrder
      }
    case HANDLE_LOBBED_PRODUCT:
      action.product.quantity = 10
      action.product.lobbedPrice = action.product.price
      return {
        ...state,
        lobbedProduct: action.product
      }
    case SET_LOBBED_QUANTITY:
      let prod = Object.assign({}, state.lobbedProduct)
      prod.quantity = action.quantity
      return {
        ...state,
        lobbedProduct: prod
      }
    case SET_LOBBED_PRICE:
      let prod1 = Object.assign({}, state.lobbedProduct)
      prod1.lobbedPrice = action.newPrice
      return {
        ...state,
        lobbedProduct: prod1
      }
    case LOADING_PRODUCTS:
      return {
        ...state,
        loading: action.loading
      }
    case LOADING_MORE_PRODUCTS:
      return {
        ...state,
        loadingMore: action.loading
      }
    case SEARCHING_PRODUCTS:
      return {
        ...state,
        loadingSearch: action.loading
      }
    case IMPORT_SEARCHED_PRODUCTS:
      return {
        ...state,
        list: state.searchList,
        searchList: [],
        searchBy: null
      }
    case CLEAR_CUSOMER_DATA:
      return productState
    case RESET_STATE:
      return productState
    case SHOWING_HOT_PRODUCTS:
      return {
        ...state,
        loaded: false,
        list: [],
        fullList: [],
        filteredList: []
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/product.js